import { IContactFilters } from 'src/pages/Contacts/CustomHooks/useContactFilters';
import Actions from 'src/components/Actions';
import Button from 'src/components/Button';
import Icon from 'src/components/Icon/FontAwesomeIcon';
import ActiveFilterPills from 'src/pages/Contacts/ActiveFilterPills/ActiveFilterPills';
import React from 'react';

interface ContactsTableActionsProps {
  onAddContact: () => void;
  onShowFilterModal?: () => void;
  hasActiveFilters: boolean;
  resetFilters: () => void;
  selectedContacts: any[];
  onSendInvitation: () => void;
  activeFilters: IContactFilters;
  removeSingleActiveFilter: any;
}

const ContactsTableActions = ({
  onAddContact,
  onShowFilterModal,
  hasActiveFilters,
  resetFilters,
  selectedContacts,
  onSendInvitation,
  activeFilters,
  removeSingleActiveFilter,
}: ContactsTableActionsProps) => {
  return (
    <div className="contactsActionBtn">
      <Actions compact>
        <div>
          <div className="filterContainer">
            <div className="filterButtons">
              <Button
                color="teal"
                label="Add Contact"
                onClick={onAddContact}
                icon={<Icon glyph="user-plus" weight="regular" size="small" />}
                size="small"
              />
              {/* Filter button */}
              {onShowFilterModal && (
                <Button
                  color="teal"
                  label="Filter"
                  onClick={onShowFilterModal}
                  icon={<Icon glyph="filter" weight="regular" size="small" />}
                  size="small"
                />
              )}
              {hasActiveFilters && (
                <Button
                  label="Clear ALl Filters"
                  onClick={resetFilters}
                  icon={<Icon glyph="filter" weight="regular" size="small" />}
                  size="small"
                />
              )}
              {selectedContacts && selectedContacts.length > 0 && (
                <Button
                  color="teal"
                  label="Send invitation link"
                  onClick={onSendInvitation}
                  icon={
                    <Icon glyph="share-square" weight="regular" size="small" />
                  }
                  size="small"
                />
              )}
            </div>
            <ActiveFilterPills
              activeFilters={activeFilters}
              removeSingleActiveFilter={removeSingleActiveFilter}
            />
          </div>
        </div>
      </Actions>
    </div>
  );
};

export default ContactsTableActions;
